// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__iiWFE","additionalInfo":"AgreementModal_additionalInfo__2mfTP"};